import axios from "axios";
import {materialCloudServicesPath} from "../../../Constants";

const restManufacturerUrl = materialCloudServicesPath + '/user/manufacturers'

export default class UserManufacturerMaterialCloudService {

    static async getAll() {
        return axios.get(restManufacturerUrl, {
            headers: {
                'Content-Type': 'application/json'
            }
        });
    }
}